// delete this after migrating back from helena
import { frontendURL } from 'dashboard/helper/URLHelper';

const MedicalRecordsHelena = () => import('./pages/MedicalRecordsHelena.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/medical-records-helena'),
    name: 'medical-records-helena',
    component: MedicalRecordsHelena,
    meta: {
      permissions: [],
      public: true,
    },
  },
  {
    path: frontendURL(
      'accounts/:accountId/contacts/:contactId/patients/:patientId/medical-records-helena/:medicalRecordId'
    ),
    name: 'new_medical_record_helena',
    component: () => import('./pages/NewMedicalRecord.vue'),
    props: route => ({
      accountId: route.params.accountId,
      patientId: route.params.patientId,
      contactId: route.params.contactId,
      medicalRecordId: route.params.medicalRecordId,
    }),
    meta: {
      permissions: [],
      public: true,
    },
  },
];
